import React from 'react';
import s from './style.module.css';

class Button extends React.Component {
    render(props) {
        return (
            <button className={ `${this.props.buttonState === true ? '' : s.mInactive} ${this.props.outline ? s.mOutline : ''} ${this.props.className} ${s.button}` } id={this.props.id} onClick={this.props.onClick}>
                {this.props.children} 
            </button>
        )
    }
}

export default Button;